import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="date-range"
// Ensures end month is always >= start month
export default class extends Controller {
  static targets = ["startMonth", "endMonth"]

  connect() {
    // Store original end month options for restoration
    this.originalEndOptions = Array.from(this.endMonthTarget.options).map(opt => ({
      value: opt.value,
      text: opt.text
    }))
    
    // Apply filter on initial load
    this.filterEndMonthOptions()
  }

  // Called when start month changes
  startMonthChanged() {
    this.filterEndMonthOptions()
  }

  filterEndMonthOptions() {
    const startValue = this.startMonthTarget.value
    const currentEndValue = this.endMonthTarget.value
    
    // Clear current options
    this.endMonthTarget.innerHTML = ''
    
    // Add only options >= start month
    let hasSelectedOption = false
    this.originalEndOptions.forEach(opt => {
      if (opt.value >= startValue) {
        const option = document.createElement('option')
        option.value = opt.value
        option.text = opt.text
        
        // Try to preserve current selection if still valid
        if (opt.value === currentEndValue) {
          option.selected = true
          hasSelectedOption = true
        }
        
        this.endMonthTarget.appendChild(option)
      }
    })
    
    // If previous selection is no longer valid, select the first available (which is the start month)
    if (!hasSelectedOption && this.endMonthTarget.options.length > 0) {
      this.endMonthTarget.options[0].selected = true
    }
  }
}
